const en = {
    'Email':'Email',
    'party':'Party',
    'Party':'Party',
    'New party':'New Party',
    'Password':'Password',
    'Remember me':'Remember me',
    'Sign In':'Sign In',
    'Sign IN':'Sign IN',
    'Sign UP':' Sign UP',
    'Dont have an account':'Dont have an account',
    'Confirm Password':'Confirm Password',
    'Name':'Name',
    'Company Name':'Company Name',
    'Address':'Address',
    'Country':'Country',
    'Select Country':'Select Country',
    'State' : 'State',
    'Select State':'Select State',
    'City':'City',
    'Zip Code':'Zip Code',
    'Phone Number':'Phone Number',
    'Already have an account?':'Already have an account?',
    'Register':'Register',
    'Contracts' : 'Contracts',
    'Contract' : 'Contract',
    'Contract Number' : 'Contract Number',
    'Logout':'Logout',
    'Company':'Company',
    'Users':'Users',
    'Type here...':'Type here...',
    'Dashboard':'Dashboard',
    'Parties':'Parties',
    'View Party':'View Party',
    'Billing':'Billing',
    'Receipts':'Receipts',
    'Processing':'Processing',
    'Reports':'Reports',
    'Search':'Search',
    'Clear':'Clear',
    'Search for Party (%for All)':'Search for Party (%for All)',
    'Party Name':'Party Name',
    'Party Type':'Party Type',
    'Entity Type':'Entity Type',
    'Select party Type':'Select Party Type',
    'Select Entity Type':'Select Entity Type',
    'Establishment Date':'Establishment Date',
    'Customer Portal':'Customer Portal',
    'Tax Number':'Tax Number',
    'Sales Tax Code':'Sales Tax Code',
    'Website':'Website',
    'Website URL':'Website URL',
    'Prefix':'Prefix',
    'Select Prefix':'Select Prefix',
    'Address Reference':'Address Reference',
    'Party Reference':'Party Reference',
    'Mr':'Mr',
    'Mrs':'Mrs',
    'Ms':'Ms',
    'First Name':'First Name',
    'Middle Name':'Middle Name',
    'Last Name':'Last Name',
    'SSN / TIN Number':'SSN/TIN Number',
    'ID Number':'ID Number',
    'Id Issue State':'Id Issue State',
    'Issue State':'Issue State',
    'Date of Birth':'Date of Birth',
    'Save' : 'Save',
    'Cancel' : 'Cancel',
    'Manage Party':'Manage Party',
    'Cutomer Type':'Cutomer Type',
    'Customer Name':'Customer Name', 	
    'Tin Number':'Tin Number', 	
    'SSN TIN Number':'SSN TIN Number', 	
    'Add Address' : 'Add Address',
    'Edit Address' : 'Edit Address',
    'Address Line 1' : 'Address Line 1',
    'Address Line 2' : 'Address Line 2',
    'Consolidate Invoice':'Consolidate Invoice',
    'Generate Invoice':'Generate Invoice pdf',
    'Pre bill days':'Pre bill days',
    'Consolidate_Invoice':'Consolidate_Invoice_Tooltip',
    'Generate_Invoice':'Generate_Invoice_Tooltip',
    'Pre_bill_days_Tooltip':'Pre_bill_days_Tooltip',
    'Y':'Y',
    'Yes':'Yes',
    'N':'N',
    'No':'No',
    'Bill To':'Bill To',
    'Select Bill To':'Select Bill To',
    'Ship To':'Ship To',
    'Select Ship To':'Select Ship To',
    'Install At':'Install At',
    'Select Install To':'Select Install To',
    'Search Install Address':'Search Install Address',
    'Update':'Update',
    'Add Contact':'Add Contact',
    'Edit Contact':'Edit Contact',
    'Phone No':'Phone No',
    'Mobile No':'Mobile No',
    'Email Address':'Email Address',
    'Manage Notification':'Manage Notifications',
    'Add Notification':'Add Notification',
    'Edit Notification':'Edit Notification',
    'Add Payment Amount':'Add Payment Amount',
    'Notification':'Notification',
    'Notification Type':'Notification Type',
    'Notification Reminder':'Notification Reminder',
    'Select notification reminder ':'Select notification reminder ',
    'Due Date Reminder':'Due Date Reminder',
    'Type':'Type',
    'Select Notification Type':'Select Notification Type',
    'Days In Advance':'Days In Advance',
    'To':'To',
    'Enable':'Enable',
    'Select':'Select',
    'New Notification':'New Notification',
    'Manage Address':'Manage Addresses',
    'Manage Contact':'Manage Contacts',
    'New Address':'New Address',
    'New Contact':'New Contact',
    'New Contract':'New Contract',
    'View Contracts':'View Contracts',
    'Manage Contracts':'Manage Contracts',
    'Net Investment':'Net Investment',
    // 'Contract Number':'Contract Number',
    'Customer':'Customer',
    'Status':'Status',
    'Start Date':'Start Date',
    'End Date':'End Date',
    'Financed Amount':'Financed Amount',
    'Preview Payment Amounts':'Preview Payment Amounts',
    'Search for Customer(%for All)':'Search for Customer(%for All)',
    'Search for Contract(%for All)':'Search for Contract(%for All)',
    'Select Address':'Select Address',
    'Bill to Address':'Bill to Address',
    'Contract Type':'Contract Type',
    'List':'List',
    'Loan':'Loan',
    'Lease':'Lease',
    'Rental':'Rental',
    'IRR/Interest p.a.':'IRR/Interest p.a. (%)',
    'Term':'Term (Months)',
    'Deposit Amount':'Deposit Amount',
    'Fees (One-Time)':'Fees (One-Time)',
    'Tax Rate (Rent)':'Override Tax Rate % (Rent)',
    'Tax Rate (Fee)':'Override Tax Rate % (Fee)',
    'Activate Contract':'Activate Contract',
    'Contract Details' : 'Contract Details',
    'Amount Financed' : 'Amount Financed',
    'Term (Months)' : 'Term (Months)',
    'Amount Billed' : 'Amount Billed',
    'Unbilled Amount' : 'Unbilled Amount',
    'Remaining Term (Months)' : 'Remaining Term (Months)',
    'No. of Assets' : 'Number of Assets',
    'Amount Due' : 'Amount Due',
    'Day Past Due' : 'Day Past Due',
    'View Amort Schedules' : 'View Amort Schedules',
    'Key Information' : 'Key Information',
    'Last Payment Amount' : 'Last Payment Amount',
    'Next Due Amount' : 'Next Due Amount',
    'Payoff Amount' : 'Payoff Amount',
    'Concurrent Contracts' : 'Concurrent Contracts',
    'Last Payment Date' : 'Last Payment Date',
    'Next Due Date' : 'Next Due Date',
    'Auto Pay' : 'Auto Pay',
    'Exposure' : 'Exposure',
    'Payment Schedules' : 'Payment Schedules',
    'No. Of Payments' : 'No. Of Payments',
    'Payment Type' : 'Payment Type',
    'Payment Lines':'Payment Lines',
    'Total Terms':'Total Terms',
    'Payment Amount' : 'Periodic Payment Amount',
    'Frequency' : 'Payment Frequency',
    'Asset' : 'Asset',
    // 'Asset No' : 'Asset No',
    'Asset No' : 'Asset Number',
    'Asset Number' : 'Asset Number',
    'Asset Description' : 'Asset Description',
    'Asset Desc' : 'Asset Desc',
    'VIN Number' : 'VIN Number',
    'Vehical Cost' : 'Vehicle Cost',
    'Asset Cost' : 'Asset Cost',
    'Loan Amount':'Loan Amount',
    'Collateral Location':'Collateral Location',
    'In Service Date' : 'In Service Date',
    'Register Address' : 'Register Address',
    'License No' : 'License No',
    'Year' : 'Year',
    'Dealer Payable' : 'Dealer Payable',
    'License State' : 'License State',
    'Manufacturer' : 'Manufacturer',
    'Make' : 'Make',
    'Model' : 'Model',
    'Use Purpose' : 'Use Purpose',
    'Residual Value' : 'Residual Value',
    'Select Install Address' : 'Select Install Address',
    'Supplier Details' : 'Supplier Details',
    'Vendor Name' : 'Vendor Name',
    'Select Vendor Name' : 'Select Vendor Name',
    'Search Vendor Name' : 'Search Vendor Name',
    'Delivery Date' : 'Delivery Date',
    'In-Service Date' : 'In Service Date',
    'Mileage' : 'Mileage',
    'Vehicle Cost' : 'Vehicle Cost',
    'Tax' : 'Tax',
    'Tax (%)' : 'Tax',
    'Borrower' : 'Borrower',
    'Dealer' : 'Dealer',
    'Trade In' : 'Trade-In',
    'Registration' : 'Registration',
    'Total Cost' : 'Total Cost',
    'Install Address' : 'Installed Address',
    'Installation Details' : 'Installation Details',
    'Down Payment' : 'Down Payment',
    'Add Assets' : 'Add Assets',
    'Add Payment Schedules' : 'Add Payment Schedules',
    'No of Payments' : 'No of Payments',
    'Rent' : 'Rent',
    'Recurring Fee' : 'Recurring Fee',
    'Fortnightly' : 'Fortnightly',
    'Monthly' : 'Monthly',
    'Quartely' : 'Quartely',
    'Semi-annual' : 'Semi-annual',
    'Annual' : 'Annual',
    'Edit Payment Schedules' : 'Edit Payment Schedules',
    'New Payment Schedules' : 'New Payment Schedules',
    'Term(Months)' : 'Term(Months)',
    'Total Rent' : 'Total Rent',
    'Total Recurring Fees' : 'Total Recurring Fees',
    'Total One Time Fees' : 'Total One Time Fees',
    'Amort Schedules' : 'Amort Schedules',
    'Due Date' : 'Due Date',
    'Date From':'Date From',
    'Date To':'Date To',
    'Amount' : 'Amount',
    'Billing Amount' : 'Billing Amount',
    'Principal' : 'Principal',
    'Interest' : 'Interest',
    'Remaining Balance' : 'Balance Due',
    'Date Billed' : 'Date Billed',
    'Transaction Number' : 'Transaction Number',
    'View Assets' : 'View Assets',
    'Asset Number' : 'Asset Number',
    'License Number' : 'License Number',
    'Items':'Items',
    'Registration Address' : 'Registration Address',
    'Vehicle Cost (Pay To)' : 'Vehicle Cost (Pay To)',
    'Tax Amount' : 'Tax Amount',
    'Trade In (Pay To)' : 'Trade-In (Pay To)',
    'Tax Amount (Pay To)' : 'Tax Amount (Pay To)',
    'Registration Cost' : 'Registration Cost',
    'Registration Cost (Pay To)' : 'Registration Cost (Pay To)',
    'Down Payment (Pay To)' : 'Down Payment (Pay To)',
    'Manage Invoices' : 'Manage Invoices',
    'Invoice Number' : 'Invoice Number',
    'Transaction Date' : 'Transaction Date',
    'Invoice Amount' : 'Invoice Amount',
    'Remaining Amount' : 'Remaining Amount',
    'Contract No' : 'Contract No',
    'Create Invoice' : 'Create Invoice',
    'Description' : 'Description',
    'Notes' : 'Notes',
    'ADD' : 'ADD',
    'Complete' : 'Complete',
    'Line Number' : 'Line Number',
    'Total' : 'Total',
    'Edit Invoice' : 'Edit Invoice',
    'Invoice Date' : 'Invoice Date',
    'Transaction Type' : 'Transaction Type',
    'Reference Number' : 'Reference Number',
    'Invoice Source' : 'Invoice Source',
    'Total Amount' : 'Total Amount',
    'Accounting Rules':'Accounting Rules',
    'Rules':'Rules',
    'Tax Report':'Tax Report',
    // 'Invoice Amount' : 'Invoice Amount',
    'Applied Amount' : 'Applied Amount',
    'Unapplied Amount':'Unapplied Amount',
    // 'Applied Amount' : 'Paid',
    'Paid' : 'Paid',
    'Invoice Comments' : 'Invoice Comments',
    'Invoice Notes' : 'Invoice Notes',
    'Invoice Details' : 'Invoice Details',
    'Line Type' : 'Line Type',
    'Line Amount' : 'Line Amount',
    'Amount Applied' : 'Amount Applied',
    'Balance Amount' : 'Balance Amount',
    'Generate Invoices' : 'Generate Invoices',
    'Generate Notifications' : 'Generate Notifications',
    'Bill Through Date' : 'Bill Through Date',
    'Refresh' : 'Refresh',
    'Request ID' : 'Request ID',
    'Process Name' : 'Process Name',
    'Error Details':'Error Details',
    'Next Run Date':'Next Run Date',
    'Parameter 1 ':'Parameter 1 ',
    'Parameter 2':'Parameter 2',
    'Request Date' : 'Request Date',
    'Select Report' : 'Select Report',
    'Contracts Register' : 'Contracts Register',
    'Invoices Register' : 'Invoices Register',
    'Receipts Register' : 'Receipts Register',
    'Receipt No' : 'Receipt Number',
    'Receipt Amount' : 'Receipt Amount',
    'Receipt Method' : 'Receipt Method',
    'Receipt Date' : 'Receipt Date',
    'Overview' : 'Overview',
    'Company Information' : 'Company Information',
    'Date of Registeration' : 'Date of Registeration',
    'Phone' : 'Phone',
    'Currency' : 'Currency',
    'Edit Company' : 'Edit Company',
    'USD' : 'USD',
    'EUR' : 'EUR',
    'GBP' : 'GBP',
    'CAD' : 'CAD',
    'AUD' : 'AUD',
    'United States' : 'United States',
    'United Kingdom' : 'United Kingdom',
    'Canada' : 'Canada',
    'Ireland' : 'Ireland',
    'Australia' : 'Australia',
    'France' : 'France',
    'Germany' : 'Germany',
    'Dutch' : 'Dutch',
    'SaveChnages' : 'SaveChnages',
    'Locale' : 'Locale',
    'Manage Users' : 'Manage Users',
    'Full Name' : 'Full Name',
    'Work Phone' : 'Work Phone',
    'Title' : 'Title',
    'Select Title' : 'Select Title',
    'Name & Occupation' : 'Name & Occupation',
    'Select Language' : 'Select Language',
    'Timezone' : 'Timezone',
    'Select Timezone' : 'Select Timezone',
    'Contact Details' : 'Contact Details',
    'Add User' : 'Add User',
    'Edit User' : 'Edit User',
    'View Receipts' : 'View Receipts',
    'Applied' : 'Applied',
    'Apply' : 'Apply',
    'Create Receipt' : 'Create Receipt',
    'Receipt Number' : 'Receipt Number',
    'Remittance Bank' : 'Remittance Bank',
    'Receipt Reference' : 'Receipt Reference',
    'Advance Amount' : 'Advance Amount',
    'Overide Application' : 'Overide Application',
    'Edit Receipt' : 'Edit Receipt',
    'View recipts' : 'View recipts',
    'InvoiceLine Details' : 'InvoiceLine Details',
    'Invoice Type' : 'Invoice Type',
    'Last Billing Date' : 'Last Billing Date',
    'Payment Period End Date' : 'Payment Period End Date',
    'Payment Period Start Date' : 'Payment Period Start Date',
    'SaveChanges' : 'SaveChanges',
    'Payment Method' : 'Payment Method',
    'Interest Posting Frequency' : 'Interest Posting Frequency',
    'Time Counting Method' : 'Day Counting Method',
    'Repayment Procedure' : 'Repayment Procedure',
    'Interest Calculation Method' : 'Interest Calculation Method',
    'Interest Rate' : 'Interest Rate (%)',
    'Payment Start Date' : 'Payment Start Date',
    'Contract Start Date' : 'Contract Start Date',
    'Contract Settings' : 'Contract Settings',
    'Automatic' : 'Automatic',
    'Manual' : 'Manual',
    'Suffix Number' : 'Suffix Number',
    'Invoice Setting' : 'Invoice Setting',
    'Starting Series of Invoice' : 'Starting Series of Invoice',
    'Select Form' : 'Select Form',
    'PartyAddress' : 'PartyAddress',
    'Invoice' : 'Invoice',
    'Receipt' : 'Receipt',
    'Enable/Disable' : 'Enable/Disable',
    'Label' : 'Label',
    'DataType' : 'DataType',
    'Serial Number' : 'Serial Number',
    'Year of Manufacture' : 'Year of Manufacture',
    'Date placed in Service' : 'Date Placed in Service',
    'Life in Months' : 'Life in Months',
    'Net Book Value' : 'Net Book Value',
    'Original Cost' : 'Original Cost',
    'Item Edit' : 'Edit Item',
    'Item Add' : 'Add Item',
    'Trade-In' : 'Trade-In',
    'Termination Date' : 'Termination Date',
    'Payments Applied' : 'Payments Applied',
    'Contracts by Month' : 'Contracts by Month',
    'Receipts by Month' : 'Receipts by Month',
    'Additional Information' : 'Additional Information',
    'Assets' : 'Assets',
    'View Contract' : 'View Contract',
    'Termination' : 'Termination',
    'Terminate Contract' : 'Terminate Contract',
    'Assets Details' : 'Assets Details',
    'Contract Edit' : 'Contract Edit',
    'Create Contract Lease' : 'Create Contract Lease',
    'Create Contract Loan' : 'Create Contract Loan',
    'Inventory' : 'Inventory',
    'View Inventory' : 'View Inventory',
    'Party Details' : 'Party Details',
    'Party Detail' : 'Party Detail',
    'Edit Party' : 'Edit Party',
    'Party Edit' : 'Party Edit',
    'Save & Continue' : 'Save & Continue',
    'Skip' : 'Skip',
    'New Receipt' : 'New Receipt',
    'Create New Receipt' : 'Create New Receipt',
    'View Receipt' : 'View Receipt',
    'New User' : 'New User',
    'Settings' : 'Settings',
    'Edit profile' : 'Edit profile',
    'Invoices' : 'Invoices',
    'New Invoice' : 'New Invoice',
    'View Invoice' : 'View Invoice',
    'Import' : 'Import',
    'Preview' : 'Preview',
    'Net Balance' : 'Net Balance',
    'Add new Party' : 'Add new Party',
    'Notification Settings' : 'Notification Settings',
    'Address Details' : 'Address Details',
    'Keep me logged in' : 'Keep me logged in',
    'Log In' : 'Log In',
    'Contact Us' : 'Contact Us',
    'Subscription Plan' : 'Subscription Plan',
    'Rate Card' : 'Rate Card',
    'View Ratecard' : 'View Ratecard',
    'Card Name' : 'Card Name',
    'Effective Form' : 'Effective Form',
    'Effective To' : 'Effective To',
    'Catagory' : 'Catagory',
    'Sub Category' : 'Sub Category',
    // 'Frequency' : 'Payment Frequency',
    'Term Form' : 'Term Form',
    'Term To' : 'Term To',
    'Rate Basis' : 'Rate Basis',
    'Product' : 'Product',
    'Asset Type' : 'Asset Type',
    'Collateral Type':'Collateral Type',
    'Payment Rule' : 'Payment Rule',
    'Total Income':'Total Income',
    'Collateral Details': 'Collateral Details',
    'Payment Additional Information' : 'Payment Additional Information',
    'Subject' : 'Subject',
    'TypeSupport' : 'Type',
    'accounts' : 'Accounts',
    'accountsetup' : 'Account setup',
    'transactiontypes' : 'Transaction Types',
    'companyuser' : 'Company User',
    'invoiceheader' : 'Invoice',
    'addextrafiled' : 'Additional Information',
    'processing' : 'Processing',
    'partynotificationsettings' : 'Party Notification Settings',
    'partycontact' : 'Party Contact',
    'ratecardheader' : 'Pricing',
    'companysettings' : 'Company Settings',
    'excelfile' : 'Bulk Import',
    'contenttype' : 'Content Type',
    'feedefination' : 'feedefination',
    'contractassets' : 'Contract Assets',
    'itemmaster' : 'Inventory',
    'paymentschedule' : 'Payment Schedule',
    'receipts' : 'Receipts',
    'contract' : 'Contract',
    'partyaddress' : 'Party Address',
    'Begin Bv' : 'Begin Book Value',
    'End Bv' : 'End Book Value',
    'OP Begin' : 'Opening Balance',
    'OP End' : 'Ending Balance',
    'View Payoff Quote' : 'View Payoff Quote',
    'Payoff Quote Number' : 'Payoff Quote Number',
    'Termination Type' : 'Termination Type',
    'Item Category' : 'Item Category',
    'Item Status' : 'Item Status',
    'Installed Location' : 'Installed Location',
    'Party Role' : 'Additional Parties',
    'Account Name':'Account Name',
    'Account Number':'Account Number',
    'Party Number':'Party Number',

    // 'Termination Date' : 'Termination Date',
    'Payoff Quote Status' : 'Payoff Quote Status',
    'Expiry Date' : 'Expiry Date',
    'Payoff Quote Details' : 'Payoff Quote Details',
    'Outstanding Receivable' : 'Outstanding Receivable',
    'Unbilled Receivable' : 'Unbilled Receivable',
    'Future Rental' : 'Future Rental',
    'Unearned Income' : 'Unearned Income',
    'Book Value' : 'Book Value',
    'Residual Booked' : 'Residual Booked',
    'Prior Outstanding' : 'Prior Outstanding',
    'Computed Payoff' : 'Computed Payoff',
    'Payoff Fee' : 'Payoff Fee',
    // 'Payoff Amount' : 'Payoff Amount',
    'Total Payoff Outstanding' : 'Total Payoff Outstanding',
    'Edit Payoff Quote' : 'Edit Payoff Quote',
    'Payoff No Of Days' : 'Payoff No Of Days',
    'No Of Days' : 'No Of Days',
    'Fee Type' : 'Fee Type',
    'Global Setting':'Global Setting',
    'Contract Numbering':'Contract Numbering',
    'Payoff Quote Number Starts From':'Payoff Quote Number Starts From',
    'Payoff Quote Validity Days':'Payoff Quote Validity Days',
    'Invoice Number Starts From':'Invoice Number Starts From',
    'Party Number Starts From':'Party Number Starts From',
    'Party Address Number Starts From':'Party Address Number Starts From',
    'Asset Number Starts From':'Asset Number Starts From',
    'Asset Type to Use':'Asset Type',
    'Receipt Number Starts From':'Receipt Number Starts From',   
    'Receipt Applied':'Receipt Applied',   
    'Transactions':'Transactions',   
    'Past Due Buckets':'Past Due Buckets',   
    'Payment History':'Payment History',
    'Ending book value':'Ending book value',
    'Combined Rate':'Combined Rate',
    'Tax Region':'Tax Region',
    'State Rate':'State Rate',
    'County Rate':'County Rate',
    'City Rate':'City Rate',
    'Special Rate':'Special Rate',
    'Comments':'Comments',
    'Application Originator':'Application Originator',
    'Source':'Source',
    'Sales Representative':'Sales Representative',
    // 'Sub Company':'Sub Company',
    'Line of Business':'Line of Business',
    'Doing Business As':'Doing Business As',
    'Business Type':'Business Type',
    'Federal ID':'Federal ID',
    'SIC':'SIC',
    'NAICS':'NAICS',
    'Risk Rating':'Risk Rating',
    'Credit Score':'Credit Score',
    'ACH Payments':'ACH Payments',
    'ACH Provider':'ACH Provider',
    'Condition':'Condition',
    'VendorAsset ID':'VendorAsset ID',
    'Salvage Value':'Salvage Value',
    'Subcompanies':'Companies',
    'Subcompany Code':'Company Code',
    'Subcompany Name':'Company Name',
    'Sub Company':'Company',
    'Bank Account':'Bank Account',
    'Business Code':'Line of Business Code',
    'Business Name':'Line of Business Name',
    'Add Party Role':'Add Additional Parties',
    'New Party Role':'New Additional Parties',
    'Edit Party Role':'Edit Additional Parties',
    'Edit Party Role':'Edit Additional Parties',
    'Role Name':'Role Name',
    'Add New Role Name':'Add New Role Name',
    'Edit Role Name':'Edit Role Name',
    'Add ACH Details':'Add ACH Account',
    'Edit ACH Details':'Edit ACH Account',
    'Basic Information':'Contract Details',
    'Interest Only Payments':'Interest Only Payments',
    'Contract Modification':'Amendment',
    'Interest Rate Type':'Interest Rate Type',
    'Base Rate':'Base Rate',
    'Margin':'Margin',

    // Dashaboard ///
    'Pending Contracts':'Pending Contracts',
    //pending contracts
    'CONTRACT NUMBER':'CONTRACT NUMBER',
    'CUSTOMER NAME':'CUSTOMER NAME',
    'TERM':'TERM',
    'START DATE':'START DATE',
    'STATUS':'STATUS',
    //invoice due
    'Invoices Due':'Invoices Due', 
    'INVOICE NUMBER':'INVOICE NUMBER',
    'AMOUNT DUE':'AMOUNT DUE',
    'PAST DUE DAYS':'PAST DUE DAYS',
    'DUE DATE':'DUE DATE',
    //conracts
    'AMOUNT FINANCED':'AMOUNT FINANCED',
    'UNBILLED AMOUNT':'UNBILLED AMOUNT',
    //unapplied payments
    'Unapplied Payments':'Unapplied Payments', 
    'Unapplied Receipts':'Unapplied Receipts', 
    'RECEIPT NUMBER':'RECEIPT NUMBER',
    'AMOUNT UNAPPLIED':'AMOUNT UNAPPLIED',
    'RECEIPT DATE':'RECEIPT DATE',

    //schedule
    'Scheduler':'Scheduler',
    'Select Processing':'Select Processing',
    'Schedule Starts':'Schedule Starts',
    'Schedule Ends':'Schedule Ends',

    //setting
    'Timeout Setting':'Timeout Setting',
    
    //process
    'requestid_Tooltip':'Request ID',
    'processname_Tooltip':'Process Name',
    'Parameter1_Tooltip':'Parameter1',
    'Parameter2_Tooltip':'Parameter2',
    'status_Tooltip':'Status',
    'errordetails_Tooltip':'Error Details',
    'nextrundate_Tooltip':'Next Run Date',
    
    //category
    "Category_Tooltip":"Category",
    "Sub_category_Tooltip":"Sub Category",
    "Index":"Index",

    //Ticketing
    "title":"Title",
    "Ticket_info":"Ticket Information",
    "priority":"Priority",
    "category":"Category",
    "subcategory":"Sub Category",
    "company":"Company",
    "assigned_to":"Assigned To",
    "created_by":"Created By",
    "created":"Created",
    "due_date":"Due Date",
    "status":"Status",
    "add_comment":"Add Comment",
    "attachments":"Attachments",
    "comments":"Comments",

    //Tooltip 
    "PartyType_Tooltip":"The type of organizations and/or persons associated to the contract.",
    "EntityType_Tooltip":"Legal structure of the business or organization.",
    "PartyName_Tooltip":"The name of the person or business of the associated party.",
    "Customer_Exposure_Tooltip":"Net investment in active contract for the customer.",
    "NetInvestment_Tooltip":"Net investment in active contract for the customer.",
    "LoanPrincipal_Tooltip":"Loan Principal in active contract for the customer.",
    "Active_contracts_Tooltip":"Number of active contracts for the customer.",
    "Consolidate invoice_Tooltip":"Consolidate invoices when a customer has multiple active contracts when invoices are due on the same date.",
    "Generate_invoice_Tooltip":"Automatically generate invoice pdf when transaction is generated.",
    "Pre_billdays_Tooltip":"Number of days in advance of the due date invoice transaction should be generated.",
    "EstablishmentDate_Tooltip":"The date on which the organization was established.",
    "TaxNumber_Tooltip":"A tax or taxpayer identification number, also known as a TIN for short, is a number issued to individuals and organizations to track tax obligations and payments they make to the Internal Revenue Service (IRS). It is issued by the federal government.",
    "SalesTaxCode_Tooltip":"ID or code associated with sales tax remittance.",
    "Website_Tooltip":"A set of related web pages located under a single domain name, typically produced by a single person or organization.",
    "Prefix_Tooltip":"Starting value, this is constant e.g. ATH for Athena Fintech",
    "Prefixsetting_Tooltip":"A title before a person's name.",
    "FirstName_Tooltip":"First name is the first of the names that you were given when you were born, as opposed to your family name.",
    "MiddleName_Tooltip":"A person's name (typically a personal name) placed after the first name and before the surname.",
    "LastName_Tooltip":"Surname, or family name.",
    "SSN/TINNumber_Tooltip":"A social security number, or SSN, is a unique identifying number associated with U.S. citizens and other residents in the country.",
    "IDNumber_Tooltip":"A number or string of numbers that is used for identification. It may be alpha-numeric.",
    "IdIssueState_Tooltip":"The state or jurisdiction in which the ID was issued.",
    "DateofBirth_Tooltip":"The month, day, and year a person was born.",
    "Address_Tooltip":"The street address or primary address information.",
    "Address2_Tooltip":"Secondary address information including the apt or suite number.",
    "City_Tooltip":"An area in which a large number of people live fairly close together.",
    "State_Tooltip":"A centralized political organization that imposes and enforces rules over a population within a territory.",
    "ZipCode_Tooltip":"A group of five or nine numbers that are added to a postal address to assist the sorting of mail.",
    "Country_Tooltip":"A nation with its own government, occupying a particular territory.",
    "BillTo_Tooltip":"The person or company listed on an invoice or some other demand for payment as the party responsible for paying for a good or service.",
    "ShipTo_Tooltip":"The physical location(s) to which products are delivered.",
    "InstallTo_Tooltip":"The physical location(s) to which products are installed.",
    "PhoneNo_Tooltip":"A number that you dial on a telephone to reach a particular person, business, etc.",
    "MobileNo_Tooltip":"The series of numbers that you dial when you are making a telephone call to their mobile phone.",
    "EmailAddress_Tooltip":"An email address identifies an email box to which messages are delivered.",
    "Notification_Tooltip":"An alert (typically a email or other message) generated by an application to notify the user of a new bill, message, update, etc.",
    "Type_Tooltip":"The way in which the notification will be distributed.",
    "DaysInAdvance_Tooltip":"The number of days, prior to the due date, that the notification will be sent.",
    "To_Tooltip":"Where the notification will be sent.",
    'Enable_Tooltip':'Make (a notification) operational; activate.',
    'Contract_Tooltip':'A contract or lease agreement by which one person (the lessor) grants a right to possession or control of an object (with or without an option to purchase) to another person (the lessee) in return for a rental or other payment.',
    'Customer_Tooltip':'The name of the person or business who leases or takes a loan on an asset.',
    'BilltoAddress_Tooltip':'The person or company listed on an invoice or some other demand for payment as the party responsible for paying for a good or service.',
    'ContractType_Tooltip':'Contract Type',
    'IRR/Interestp.a_Tooltip':'Implicit Interest Rate is the rate at which the present value of the lease payments and the unguaranteed residual value equal the sum of the fair value of the underlying asset and any initial direct costs of the lessor.',
    'Term_Tooltip':'The period of time in which a contracted lease is in place.',
    'StartDate_Tooltip':'The date on which your lease begins and you become legally responsible for the asset being leased.',
    'EndDate_Tooltip':'The last day of the Lease Period as stipulated in the Lease Agreement or the Lease Termination Date whichever comes first.',
    'DepositAmount_Tooltip':'The amount of prepaid rent and security deposits held.',
    'Fees-Onetime_Tooltip':'The amount of one-time fees associated to the lease contract.',
    'TaxRate-Rent_Tooltip':'The tax rate applied to the total amount of the rental payment, including any local discretionary sales surtaxes.',
    'TaxRate-Fee_Tooltip':'The tax rate applied to the total amount of the rental fees, including any local discretionary sales surtaxes.',
    'AssetNo_Tooltip':'Uniquely identifies the product purchased or leased.',
    'AssetDesc_Tooltip':'Brief description of the asset.',
    'LicenseNo_Tooltip':'The license number associated with the asset.',
    'FinancedAmount_Tooltip':'The initial financed amount of the asset.',
    'Year_Tooltip':'The calendar year in which a unit was manufactured.',
    'VINNumber_Tooltip':'The Vehicle Identification Number (VIN number) that is assigned to the current asset.',
    'LicenseState_Tooltip':'The state in which the asset is licensed.',
    'DealerPayable_Tooltip':'The amount payable to the dealer.',
    'Manufacturer_Tooltip':'The producer of the asset.',
    'Make_Tooltip':'The brand of the asset.',
    'Model_Tooltip':'A combination of letters, digits, or characters representing the manufacturer, brand, design, or performance of an asset.',
    'UsePurpose_Tooltip':'The intended use of the asset.',
    'ResidalValue_Tooltip':'The value of an asset at the end of a lease term.',
    'InstallAddress_Tooltip':'The place where the asset will be located.',
    'VendorName_Tooltip':'The name of the vendor who supplied the asset.',
    'DeliveryDate_Tooltip':'The calendar date on which an asset was delivered.',
    'In-ServiceDate_Tooltip':'The calendar date on which an asset could start to be used.',
    'Mileage_Tooltip':'The odometer reading on the asset.',
    'VehicleCost_Tooltip':'The initial cost or purchase price of the asset.',
    'Tax_Tooltip':'The tax associated with the purchase of the asset.',
    'TradeIn_Tooltip':'The trade-in amount received if an asset was traded to purchase this asset.',
    'Registration_Tooltip':'The amount of the registration fees.',
    'TotalCost_Tooltip':'Total cost of the asset before any payments are made. ',
    'DownPayment_Tooltip':'Amount paid at the time of purchase or delivery of the asset.',
    'NoofPayments_Tooltip':'The number of payments during the schedule period.',
    'PaymentAmount_Tooltip':'The amount due for each payment.',
    'PaymentType_Tooltip':'The means by which customers pay for the loan.',
    'Frequency_Tooltip':'The frequency of payment required for regular payment amounts set out on the loan.',
    'CustomerName_Tooltip':'The name of the individual to be invoiced for the loan or lease.',
    'ContractNumber_Tooltip':'The contract number of the loan or lease associated to this invoice.',
    'ContractNumbersetting_Tooltip':'The sequence number of contract number to be applied.',
    'DueDate_Tooltip':'The day the payment is due.',
    'InvoiceAmount_Tooltip':'The amount due for this invoice.',
    'Description_Tooltip':'A short description explaining the purpose of the invoice.',
    'Notes_Tooltip':'Explanation or notes related to this invoice.',
    'LineNumber_Tooltip':'Reference number of the invoice.',
    'Amount_Tooltip':'Amount associated with this line item.',
    'Total_Tooltip':'The amount due for this line item.',
    'Email_Tooltip':'An email address identifies an email box to which messages are delivered.',
    'Locale_Tooltip':'Geographic place or location where the company resides.',
    'Currency_Tooltip':'Primary currency used by the company.',
    'PhoneNumber_Tooltip':'A number that you dial on a telephone to reach a particular person, business, etc.',
    'CompanyName_Tooltip':'Business name associated with the company.',
    'LenderID_Tooltip':'Unique identifier assigned to the lender for this company.',
    'Name_Tooltip':'The name of the user.',
    'Title_Tooltip':"A name that describes someone's position or job.",
    'Language_Tooltip':'The language the user speaks in.',
    'Timezone_Tooltip':"Any of the 24 divisions of the Earth's surface used to determine the local time for any given locality",
    'Phone_Tooltip':'A number that you dial on a telephone to reach a particular person, business, etc.',
    'WorkPhone_Tooltip':'A number that you dial on a telephone to reach a particular person, business, etc.',
    'ReceiptNumber_Tooltip':'Reference number of the receipt.',
    'RemittanceBank_Tooltip':'The bank which initiated the transfer of money.',
    'ReceiptDate_Tooltip':'The date the payment was received.',
    'ReceiptMethod_Tooltip':'The method by which the funds were received.',
    'ReceiptAmount_Tooltip':'The amount received for this receipt.',
    'ReceiptReference_Tooltip':'A short description or reference number related to the receipt.',
    // 'AppliedAmount_Tooltip':'The amount that has been applied from this receipt.',
    'AppliedAmount_Tooltip':'Amount paid on this invoice',
    'AppliedAmountReceipt_Tooltip':'Amount Applied from this Receipt',
    'AdvanceAmount_Tooltip':'Hold automatic application and only permit manual application of funds',
    'OverideApplication_Tooltip':'Manually select bills to be applied',
    'Status_Tooltip':'Status',
    'LastBillingDate_Tooltip':'Last Billing Date',
    'PaymentPeriodStartDate_Tooltip':'Payment Period Start Date',
    'PaymentPeriodEndDate_Tooltip':'Payment Period End Date',
    'ItemName_Tooltip':'Brief name of the asset.',
    'Quantity_Tooltip':'Number of units for this record. The Serial Numbers table below will have one row per unit.',
    'SerialNumber_Tooltip':'Uniquely identifies the product purchased or leased.',
    'YearofManufacturer_Tooltip':'The calendar year in which a unit was manufactured.',
    'DateplacedinService_Tooltip':'The calendar date on which an asset could start to be used.',
    'LifeinMonths_Tooltip':"Total remaining number of months in the asset's useful life.",
    'NetBookValue_Tooltip':'The historical cost of an asset, less any amounts recorded for depreciation, amortization, or depletion.',
    'OriginalCost_Tooltip':'The total price associated with the purchase of an asset.',
    'Number_Tooltip':'Number',
    'Manage Customer Portal Users':'Manage Customer Portal Users',
    'Suffixnumber_Tooltip':'Ending value, this is constant e.g. C for Contract',
    'StartingSeriesofInvoice_Tooltip':'Starting number which will be incremented for each new invoice created e.g. 10000 or 1001',
    'PaymentMethod_Tooltip':'How payments are received. In advance or arrears.',
    'InterestPostingFrequency_Tooltip':'The frequency in which the accrued interest is applied in the account.',
    'TimeCountingMethod_Tooltip':'Methodology for calculating the number of days between two dates.',
    'RepaymentProcedure_Tooltip':'Method in which interest expenses are calculated.',
    'InterestCalculationMethod_Tooltip':'The interest calculation method is a day count convention (procedure for counting days) for interest calculation. It specifies how a part of the year between two calendar dates is determined.',
    'InterestRate_Tooltip':'The proportion of the loan that is charged as interest to the borrower, expressed as an annual percentage.',
    'LoanAmount_Tooltip':'The amount of money owed under this contract.',
    'PaymentStartDate_Tooltip':'Payment Start Date',
    'ContractStartDate_Tooltip':'The date on which a Loan Arrangement is to commence.',
    'Contractloan_Tooltip':'Any written agreement under which a qualified lender lends or agrees to lend funds to a borrower.',
    'SelectFormfor_Tooltip':'Select Form for',
    'Amountfinanced_Tooltip':'Amount Financed',
    'AmountBilled_Tooltip':'Amount Billed',
    'AmountUnbilled_Tooltip':'Amount UnBilled',
    'NumberofAssets_Tooltip':'Number of Assets',
    'RemainingTerm(Months)_Tooltip':'Remaining Term(Months)',
    'AmountDue_Tooltip':'Amount Due',
    'DayPastDue_Tooltip':'Number of days past due to be ignored for past due reminders',
    'TerminationDate_Tooltip':'Termination Date',
    'LastPaymentAmount_Tooltip':'Last Payment Amount',
    'NextDueAmount_Tooltip':'Next Due Amount',
    'PayoffAmount_Tooltip':'Payoff Amount',
    'ConcurrentContracts_Tooltip':'Concurrent Contracts',
    'LastPaymentDate_Tooltip':'Last Payment Date',
    'NextDueDate_Tooltip':'Next Due Date',
    'AutoPay_Tooltip':'Auto Pay',
    'Exposure_Tooltip':'Exposure',
    'TotalRent_Tooltip':'Total Rent',
    'TotalRecurringFees_Tooltip':'Total Recurring Fees',
    'TotalOneTimeFees_Tooltip':'Total One Time Fees',
    'VehicleCost(Pay To)_Tooltip':'Vehicle Cost (Pay To)',
    'RegistrationCost_Tooltip':'Registration Cost',
    'RegistrationCost(Pay To)_Tooltip':'Registration Cost (Pay To)',
    'TaxAmount(Pay To)_Tooltip':'Tax Amount (Pay To)',
    'TradeIn(Pay To)_Tooltip':'Trade In (Pay To)',
    'DownPayment(Pay To)_Tooltip':'Down Payment (Pay To)',
    'NetBalance_Tooltip':'Net Balance',
    'InvoiceDate_Tooltip':'Invoice Date',
    'TransactionType_Tooltip':'Transaction Type',
    'ReferenceNumber_Tooltip':'Reference Number',
    'InvoiceSource_Tooltip':'Invoice Source',
    'InvoiceComments_Tooltip':'Invoice Comments',
    'InvoiceNumber_Tooltip':'Invoice Number',
    'TotalAmount_Tooltip':'Amount payable for this invoice',
    'RemainingBalance_Tooltip':'Balance due for this invoice',
    'ReceiptNo_Tooltip':'Receipt No',
    'Numbersetting_Tooltip':'Starting number which will be incremented for each new contract created e.g. 10000 or 1001',
    'Product_Tooltip':'Product',
    'Amountrate_Tooltip':'Amount',
    'Ratebasis_Tooltip':'Rate Basis',
    'TermTo_Tooltip':'Term To',
    'TermFrom_Tooltip':'Term From',
    'FrequencyRate_Tooltip':'Frequency',
    'EffectiveFrom_Tooltip':'Effective From',
    'EffectiveTo_Tooltip':'Effective To',
    'CardName_Tooltip':'Card Name',
    'ratecardline_Tooltip':'rate card line number',
    'Assettype_Tooltip':'Asset Type',
    'PaymentRule_Tooltip':'Payment Rule ',
    'Subject_Tooltip':'Reason for this ticket',
    'Message_Tooltip':'Enter details of the ticket including screenshots, if applicable',
    'Typesupport_Tooltip':'Type',
    'QuoteNumber_Tooltip':'Payoff Quote Number',
    'TerminationType_Tooltip':'Termination Type',
    // 'TerminationDate_Tooltip':'Termination Date',
    'QuoteStatus_Tooltip':'Payoff Quote Status',
    'ExpiryDate_Tooltip':'Expiry Date',
    'OutstandingAR_Tooltip':'Outstanding Receivable',
    'UnbilledAR_Tooltip':'Unbilled Receivable',
    'FutureRental_Tooltip':'Future Rental',
    'UnearnedIncome_Tooltip':'Unearned Income',
    'BookValue_Tooltip':'Book Value',
    'ResidualBooked_Tooltip':'Residual Booked',
    'PriorOutstanding_Tooltip':'Prior Outstanding',
    'ComputedPayoff_Tooltip':'Computed Payoff',
    'PayoffFee_Tooltip':'Payoff Fee',
    'PayoffType_Tooltip':'Payoff Type',
    // 'PayoffAmount_Tooltip':'Payoff Amount',
    'TotalPayoffOutstanding_Tooltip':'Total Payoff Outstanding',
    'Noofdays_Tooltip':'Payoff No of Days',
    'Feetype_Tooltip':'Fee Type',
    'PastDueBuckets_Tooltip':'Past Due Buckets',
    'Endingbookvalue_Tooltip':'Ending Book Value',
    'PaymentFrequency_Tooltip':'Payment Frequency',
    'invoicetemplate_Tooltip':'Invoice Template',
    'StartingSeriesofParty_Tooltip':'Starting Series of Party',
    'StartingSeriesofAddress_Tooltip':'Starting Series of Address',
    'StartingSeriesofAsset_Tooltip':'Starting Series of Asset',
    'StartingSeriesofReceipt_Tooltip':'Starting Series of Receipt',
    'Zipcode_Tooltip':'Zip Code',
    'TaxRegion_Tooltip':'Tax Region',
    'CombinedRate_Tooltip':'Combined Rate',
    'StateRate_Tooltip':'State Rate',
    'CountyRate_Tooltip':'County Rate',
    'CityRate_Tooltip':'City Rate',
    'SpecialRate_Tooltip':'Special Rate',
    'ResidualValue_Tooltip':'Residual Value',
    'Comments_Tooltip':'Comments',
    'CreationDate_Tooltip':'Creation Date',
    'DeActivatedate_Tooltip':'DeActivate Date',
    'Lineofbusiness_Tooltip':'Line of Business',
    'Businesscode_Tooltip':'Line of Business Code',
    'Businessname_Tooltip':'Line of Business Name',
    'setasdefault_Tooltip':'Set as Default',
    'Subcompany_Tooltip':'Company',
    'Suncompanyname_Tooltip':'Company Name',
    'Suncompanycode_Tooltip':'Company Code',
    'SalesRep_Tooltip':'Sales Representative',
    'Source_Tooltip':'Source',
    'ApplicationOrginator_Tooltip':'Application Orginator',
    'DaysPastDue_Tooltip':'Number of days past due to be ignored for past due reminders',
    'DoingBusinessAs_Tooltip':'Alternate Name',
    'Business_Type_Tooltip':'Organization type e.g. LLC, Corporation, etc.',
    'FederalID_Tooltip':'Federal Identity',
    'SIC_Tooltip':'Standard Industrial Classification code',
    'NAICS_Tooltip':'North american industry classification system (NAICS) code',
    'RiskRating_Tooltip':'Internal Risk Rating',
    'CreditScore_Tooltip':'Party’s Credit Score',
    'Ach_Payments_Tooltip':'Enable payment processing for the customer through ACH',
    'Condition_Tooltip':'Condition',
    'VendorAssetID_Tooltip':'Vendor Asset ID',
    'Salvagevalue_Tooltip':'Salvage Value',
    'Role_Tooltip':'Role',
    'Party_Tooltip':'Party',
    'bankaccount_Tooltip':'Bank Account',
    'immediate_destination_Tooltip':'The nine-digit routing number of the institution receiving the ACH file for processing, preceded by a blank. Typically, this is your bank’s routing and transit number.',
    'Immediatedestname_Tooltip':'Name of the financial institution receiving the payment file.',
    'immediate_origin_Tooltip':'The nine-digit routing transit number of the institution sending (originating) the ACH file, preceded by a blank. (Often your ODFI will have you insert your company ID in this field.)',
    'immediate_origin_name_Tooltip':'Name of the financial institution sending the payment file',
    'CompanyIdentification_Tooltip':'Used to identify the Originator.  Assigned by the ODFI',
    'StandardEntryClassCode_Tooltip':'Standard entry class code, usually 3 digits. Identifies the entries in the batch. Common standard entry class codes are: PPD (Prearranged Payments and Deposit entries) for consumer items, CCD (Cash Concentration and Disbursement entries) and CTX (Corporate Trade Exchange entries) for corporate transactions.',
    'OriginatingBankFID_Tooltip':'Originating Depository Financial Institution (ODFI) Identification Number. Identifier (or routing number) for the bank originating the transaction.',
    'OriginatorTaxID_Tooltip':' Tax ID of the bank originating the ACH transaction.',
    'ACHOperatorname_Tooltip':'Name of the ACH operator or the receiving point of the ACH file.',
    'Destination_Tooltip':'10 digit code for service operator',
    'DestinationName_Tooltip':'Routing Number preceded by a blank.',
    'ServiceClassCode_Tooltip':'Dentifies the type of entries in the batch: 200 - ACH Entries Mixed Debits and Credits  220 - ACH Credits Only 225 - ACH Debits Only ( This is to be used) Set to 225',
    'RoleName_Tooltip':'Role Name',
    'title_Tooltip':'Title of the Ticket',
    'description_Tooltip':'Description of the Ticket',
    'priority_Tooltip':'Priority of the Ticket',
    'category_Tooltip':'Category of the Ticket',
    'subcategory_Tooltip':'Subcategory of the Ticket',
    'company_Tooltip':'Company associated with the Ticket',
    'assigned_to_Tooltip':'User assigned to the Ticket',
    'created_by_Tooltip':'User who created the Ticket',
    'created_Tooltip':'Creation date of the Ticket',
    'due_date_Tooltip':'Due date of the Ticket',
    'Status_Tooltip':'Status of the Ticket',
    'add_Comment_Tooltip':'Add a comment to the Ticket',
    'upload_attachment_Tooltip':'Upload an attachment to the Ticket',
    'InterestOnlyPayments_Tooltip':'Interest Only Payments',
    'reverseComments_Tooltip':'Reason of Reversal',
    'InterestRateType_Tooltip':'Interest Rate Type',
    'BaseRate_Tooltip':'Base Rate',
    'Margin_Tooltip':'Margin'


}   
export default en;